// extracted by mini-css-extract-plugin
export default {"list":"EditMenu_list__ivNjW","listItem":"EditMenu_listItem__GNnAJ"};